export const SERVER_URL = "https://devpub-mocks.herokuapp.com";
